module.exports = __webpack_public_path__ + "media/pages/assets/images/book-with-apple-e3c3d5e2cba3aca9193ec0548ebfd384.svg";